import index from './index.js';
import pick from './pick.js';
import { Router } from '@/legacy/Router';
import slideshow from './slideshow.js';

Router.get('entry/pick/([a-zA-Z]+)/([a-zA-Z]+)', pick);
Router.get('entry/pick/([a-zA-Z]+)/([a-zA-Z]+)/slideshow', slideshow);
Router.get('entry/pick', index);
